<div class="dialog">
  <div mat-dialog-title
       class="dialog-title">
    <h1>{{ 'global.dialogs.qr-code.title' | translate }}</h1>
  </div>
  <div mat-dialog-content
       class="dialog-content">
    <div>
      <qrcode [qrdata]="data.qrCode"
              [width]="256"
              [errorCorrectionLevel]="'M'"></qrcode>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions
       class="dialog-actions">
    <button mat-stroked-button
            (click)="close()">
      {{ 'global.buttons.close' | translate }}
    </button>
  </div>
</div>